import './AthleteSearchBar.css';

import React from 'react';

import SearchIcon from './SearchIcon';

export interface AthleteSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
}

const AthleteSearchBar: React.FC<AthleteSearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Search by name or number',
  ariaLabel = 'Search athletes',
}) => (
  <div className="athlete-search-bar">
    <div className="athlete-search-bar__inner">
      <SearchIcon className="athlete-search-bar__icon" />
      <input
        className="athlete-search-bar__input"
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
      {value ? (
        <button
          type="button"
          className="athlete-search-bar__clear"
          onClick={() => onChange('')}
          aria-label="Clear search"
        >
          ×
        </button>
      ) : null}
    </div>
  </div>
);

export default AthleteSearchBar;
